import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { DOCS_DEFAULT_SLUG } from '../../config/docsNav';
import { docsPages } from './docsContent';

const DocsPage = () => {
    const { slug } = useParams();
    const page = docsPages[slug];

    if (!page) {
        return <Navigate to={`/docs/${DOCS_DEFAULT_SLUG}`} replace />;
    }

    if (page.isHero) {
        return <article className="pb-8">{page.content}</article>;
    }

    return (
        <article className="pb-16">
            <header className="mb-10 border-b border-zinc-200 pb-8 dark:border-zinc-800">
                <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-teal-700 dark:text-teal-400">
                    CronPay Docs
                </p>
                <h1 className="text-3xl font-bold tracking-tight text-zinc-900 dark:text-white sm:text-4xl">
                    {page.title}
                </h1>
            </header>
            <div className="docs-article-body">{page.content}</div>
        </article>
    );
};

export default DocsPage;
